<template>
  <div class="image-view__wrp" v-show="show" v-on:keyup.esc="close" v-on:click="close">
    <div class="image-view__bak"></div>
    <div class="image-view" tabindex="-1" hidefocus="true" v-if="src" ref="imgView">
      <img :src="src" @load="onImageLoad" ref="img" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: null,
      show: false
    };
  },
  methods: {
    close() {
      this.show = false;
    },
    setImage(src) {
      var me = this;
      me.src = src;
      me.show = true;
      me.$nextTick(function() {
        // 保证esc事件发生在当前ImageViewer
        me.$refs.imgView.focus();
      });
    },
    onImageLoad() {
      // 居中显示
      var img = this.$refs.img,
        maxWidth = window.innerWidth,
        width = img.width,
        widthPerc = maxWidth / width,
        maxHeight = window.innerHeight,
        height = img.height,
        heightPerc = maxHeight / height,
        perc = Math.min(widthPerc, heightPerc),
        zoom = perc < 1 ? perc : 1;
      img.style.zoom = zoom;
    }
  }
};
</script>

<style>
.image-view__bak {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100vh;
  z-index: 1100;
  background-color: rgba(0, 0, 0, 0.5);
  filter: alpha(opacity=50);
}
.image-view {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1150;
  overflow: hidden;
  outline: 0;
  -webkit-overflow-scrolling: touch;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-view img {
  height: auto;
  max-height: 100vh;
  max-width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: zoom-out !important;
}
</style>